import React, { useEffect, useState } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';

export function useActiveElement() {
  const { isSSR } = useEnvironment();
  const [activeElement, setActiveElement] = useState<HTMLElement | null>(
    isSSR ? null : (document.activeElement as HTMLElement),
  );

  useEffect(() => {
    function handleFocusIn() {
      setActiveElement(document.activeElement as HTMLElement);
    }

    window.addEventListener('focusin', handleFocusIn);

    return () => {
      window.removeEventListener('focusin', handleFocusIn);
    };
  }, []);

  return activeElement;
}
